import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowDownRightSm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m9.224 8 6.682.094m0 0L16 14.777m-.094-6.683L8 16"
    />
  </svg>
);
export default SvgArrowDownRightSm;
